import { render } from "./ThemeToggle.vue?vue&type=template&id=2b523a50"
import script from "./ThemeToggle.vue?vue&type=script&lang=js"
export * from "./ThemeToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__